import { AfterViewInit, ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatLegacyFormFieldAppearance as MatFormFieldAppearance } from '@angular/material/legacy-form-field';
import { MatLegacyInput as MatInput } from '@angular/material/legacy-input';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take, tap } from 'rxjs';
import { AbstractListViewService } from '../abstract-list-view.service';

@UntilDestroy()
@Component({
  selector: 'y42-list-view-search-field',
  templateUrl: './list-view-search-field.component.html',
  styleUrls: ['./list-view-search-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewSearchFieldComponent implements AfterViewInit {
  constructor(private readonly service: AbstractListViewService) {}

  @Input() searchLabel = '';
  @Input() searchPlaceholder = '';
  @Input() searchCtrl!: FormControl<string | null>;
  @Input() searchFieldClasses!: string;
  @Input() searchFieldAppearance!: MatFormFieldAppearance;

  @ViewChild(MatInput, { static: true }) input?: MatInput;

  ngAfterViewInit() {
    this.service.data$
      .pipe(
        filter((data) => data.length > 4),
        tap(() => this.input?.focus()),
        take(1),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
